import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    connectPayment,
    connectPaymentSuccess,
    connectPaymentFailure,
    completeConnectionPaymentSuccess,
    completeConnectionPaymentFailure,
    completeConnectionPayment,
    getPayment,
    getPaymentFailure,
    getPaymentSuccess,
    disconnectPayment,
    disconnectPaymentSuccess,
    disconnectPaymentFailure,
    registerPayment,
    registerPaymentSuccess,
    registerPaymentFailure,
    getCollectMaster,
    getCollectMasterSuccess,
    getCollectMasterFailure,
    connectCollectMaster,
    connectCollectMasterSuccess,
    connectCollectMasterFailure,
    disconnectCollectMaster,
    disconnectCollectMasterSuccess,
    disconnectCollectMasterFailure
} from './payment-gateway.action';

import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';

@Injectable()
export class PaymentGatewayRecordEffects {

    getPayment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(getPayment),
            exhaustMap(() => {

                const url = 'mollie/status';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        return getPaymentSuccess({hasConnect: response.data.hasConnect, hasManualConnect: response.data.hasManualConnect});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => getPaymentFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    connectPayment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(connectPayment),
            exhaustMap((data: any) => {
                const url = 'mollie/connect'+"?is_manual="+data.isManual;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        if(response.data.url == "manual")
                            this.store.dispatch(getPayment());

                        return connectPaymentSuccess({connectUrl: response.data.url, loading: (response.data.url == "manual")});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => connectPaymentFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    registerPayment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(registerPayment),
            exhaustMap(() => {
                const url = 'mollie/register';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        return registerPaymentSuccess({connectUrl: response.data.url});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => registerPaymentFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    completeConnectionPayment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(completeConnectionPayment),
            exhaustMap((data: any) => {
                const url = 'mollie/callback';
                return this.crudServerService.addData(url, data).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(getPaymentSuccess({hasConnect: response.data.hasConnect, hasManualConnect: response.data.hasManualConnect}));
                        return completeConnectionPaymentSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => completeConnectionPaymentFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    disconnectPayment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(disconnectPayment),
            exhaustMap(() => {
                const url = 'mollie/disconnect';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(getPaymentSuccess({hasConnect: response.data.hasConnect, hasManualConnect: response.data.hasManualConnect}));
                        return disconnectPaymentSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => disconnectPaymentFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    getCollectMaster$ = createEffect(() =>
        this.actions$.pipe(
            ofType(getCollectMaster),
            exhaustMap(() => {

                const url = 'collect-master/status';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        return getCollectMasterSuccess({hasCollectMaster: response.data.hasCollectMaster});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => getCollectMasterFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    connectCollectMaster$ = createEffect(() =>
        this.actions$.pipe(
            ofType(connectCollectMaster),
            exhaustMap(() => {
                const url = 'collect-master/connect';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(getCollectMaster());
                        return connectCollectMasterSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => connectCollectMasterFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    disconnectCollectMaster$ = createEffect(() =>
        this.actions$.pipe(
            ofType(disconnectCollectMaster),
            exhaustMap(() => {
                const url = 'collect-master/disconnect';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(getCollectMaster());
                        return disconnectCollectMasterSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => disconnectCollectMasterFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );
    
    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>
    ) { }

}